import React from 'react';

// False while a kept-alive page (e.g. /messages) is mounted but hidden.
export const PaneActiveContext = React.createContext(true);
